import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Button, Col, Row } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'

import ExcelReader from 'components/ExcelReader'
import ExcelTable from 'components/ExcelTable'
import ExcelTemplate from 'components/ExcelTemplate'
import AssignExcelUsers from './AssignExcelUsers'


import { updateExcelUsers } from 'redux/actions/marketing'


const Step2ImportExcel = (props) => {
  const {
    closeView,
    marketing: { excelData },
    additionalExcelUsers,
  } = props

  const dispatch = useDispatch()

  const [isShowExcelTable, setIsShowExcelTable] = useState(false)
  const [showAssignExcelUsers, setShowAssignExcelUsers] = useState(false)
  const [showExcelReader, setShowExcelReader] = useState(true)
  const [selectedExcelUsers, setSelectedExcelUsers] = useState([])
  const [excelUsersToShow, setExcelUsersToShow] = useState([])

  useEffect(() => {
    if (excelData.rows && excelData.rows > 0) {
      setShowAssignExcelUsers(true)
      setShowExcelReader(false)
    }
    return () => setShowAssignExcelUsers(false)
  }, [excelData])

  const onSubmit = () => {
    const data = selectedExcelUsers
    const excelUsers = data.map((user) => ({
      name: user.name,
      lastName: user.lastName,
      identifier: user.phone || user.channelId,
      channel: user.channel,
      occasionId: user.occasion_id || '',
      occasionName: user.occasion_name || '',
      brand: user.brand,
      delegation: user.delegation,
      codcliente: user.codcliente || ''
    }))
    dispatch(updateExcelUsers(excelUsers))

    // update table with total users: tickets and excelusers
    additionalExcelUsers(excelUsers)
    closeView()
  }

  const showPreview = (excelUsers) => {
    setIsShowExcelTable(true)
    setShowAssignExcelUsers(false)
    setShowExcelReader(false)
    setExcelUsersToShow(excelUsers)
  }

  const removeExcel = () => {
    setIsShowExcelTable(false)
    setShowAssignExcelUsers(false)
    setShowExcelReader(true)
    setExcelUsersToShow([])
  }

  return (
    <>
      <Row className='my-3'>
        <Col xs="12">
          <div className='select-recipients'>
            <Row className='header'>
              <Col className='col-md-auto' xs="11">
                <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'row' }}>
                  <img src='./img/icons/icon-excel.svg' alt='user' />
                  <div className='select-recipients-text' style={{ width: 'unset' }}>{I18n.t('import_excel')}</div>
                  { showAssignExcelUsers ?
                    <Button color='primary' size='sm' onClick={removeExcel} style={{ marginLeft: '10px' }}>
                      {I18n.t('dashboard_edit')}
                    </Button> : null
                  }
                </div>
              </Col>

              <Col xs="1" className='col-md-auto text-right'>
                <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Close' onClick={closeView} />
              </Col>
            </Row>

            {/** SHOW PREVIEW excel table */}
            {isShowExcelTable && (
              <>
                <Row>
                  <Col>
                    <span className='import-excel-back pointer' onClick={closeView}>
                      <i className='fa fa-arrow-left'></i> {I18n.t('dashboard_go-back')}
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col className='import-excel-table-wrapper'>
                    <ExcelTable
                      users={excelUsersToShow}
                      selectedExcelUsers={setSelectedExcelUsers}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className='text-center'>
                    <Button color='primary' size='lg' onClick={onSubmit}>
                      <i className='fa fa-arrow-down'></i> {I18n.t('campaign_add_recipients', { count: selectedExcelUsers.length })}
                    </Button>
                  </Col>
                </Row>
              </>
            )}
            {/** SHOW ASSIGN EXCEL USERS */}
            {showAssignExcelUsers && (
              <Row>
                <Col className='import-excel-table-wrapper'>
                  <AssignExcelUsers
                    excelUsers={excelData}
                    showPreview={showPreview}
                  />
                </Col>
              </Row>
            )}
            {/** SHOW ASSIGN EXCEL READER */}
            {showExcelReader && (
              <>
                <Row className='import-excel-container'>
                  <Col className='import-excel-wrapper text-center col-3'>
                    <ExcelTemplate />
                  </Col>
                  <Col className='import-excel-wrapper reader text-center col-7'>
                    <p className={'label-3'}>{I18n.t('upload_excel_user_data')}</p>
                    <ExcelReader />
                    <p className={'label-4'}>
                      {I18n.t('upload_excel_accepted_formats')} {I18n.t('upload_excel_max_size')}{' '}
                    </p>
                  </Col>
                </Row>
              </>
            )}
          </div>
        </Col>
      </Row>
    </>
  )
}

export default connect((state) => ({ marketing: state.marketing }))(Step2ImportExcel)
